import {httpGatewayService} from '@/modules/common/services';

const getDirectory = async () => {
  let result;
  try {
    result = await httpGatewayService.get(`v3/business_administration/directories`);
    result = result.data;
  } catch (error) {
    result = {code: 'error', error};
    console.error(error);
  }

  return result;
};

export const directoryService = {
  getDirectory
};
